import { useTheme } from '@emotion/react';
import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Alert, Button, Modal, Text } from '~/components/blocks';
import { twoFactorAuthModalState } from '~/state/layouts/SharedAppShell/atoms';

import { useDeactivateOtpSecrets } from './use-deactivate-otp_secrets';

export const ActivatingPanel = () => {
  const theme = useTheme();

  const { deactivating, error, handleSubmit } = useDeactivateOtpSecrets();

  const setTwoFactorAuthModalState = useSetAtom(twoFactorAuthModalState);
  const handleClickSetting = useCallback(
    () => setTwoFactorAuthModalState((_state) => ({ ..._state, currentPanel: 'scan' })),
    [setTwoFactorAuthModalState],
  );

  return (
    <>
      <Modal.Body>
        {error && <Alert marginBottom={theme.space.l}>{error}</Alert>}
        <Text>
          現在、<strong>二要素認証が有効</strong>です。
        </Text>
        <Text block>再設定すると、以前の二要素認証は無効になります</Text>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={deactivating} onClick={handleClickSetting}>
          再設定
        </Button>
        <Button
          use="secondary"
          marginLeft={theme.space.l}
          loading={deactivating}
          onClick={handleSubmit}
        >
          無効
        </Button>
      </Modal.Footer>
    </>
  );
};
